/** @format */

import clsx from 'clsx';
import { type ButtonHTMLAttributes, type ReactNode } from 'react';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  additionalClassName?: string;
  label?: ReactNode;
  secondary?: boolean;
  arrow?: boolean;
  noArrow?: boolean;
  check?: boolean;
  borderOnly?: boolean;
  tertiary?: boolean;
  small?: boolean;
  ghost?: boolean;
  text?: boolean;
  back?: boolean;
  dark?: boolean;
};

export const Button = (props: ButtonProps) => {
  const {
    className,
    additionalClassName,
    children,
    label,
    secondary,
    arrow,
    noArrow: _noArrow,
    check,
    borderOnly,
    tertiary,
    small,
    ghost,
    text,
    back,
    dark,
    ...rest
  } = props;
  return (
    <button
      className={clsx(
        dark && 'dark',
        secondary || borderOnly || ghost || text ? 'secondary' : className || `primary`,
        (tertiary || small) && 'small',
        (ghost || text) && 'text',
        arrow && 'arrow-icon',
        check && 'check-icon',
        back && 'back-icon',
        additionalClassName
      )}
      {...rest}>
      {label || children}
    </button>
  );
};
